import type { AppLocale } from './locales'

const en = {
  barTitle: 'Get a heads-up before BUFFs expire',
  barLead: 'Add a BUFF and connect your game window.',
  barDescription: ' Monitoring starts automatically.',
  barHint: 'Drag BUFF icons to change their order.',
  addTitle: 'Click “+” to add a BUFF',
  addLead: 'Search skills or items,',
  addDescription: ' then click an icon to add it.',
  addHint: 'Have your own icon? Upload, paste, or drop its image.',
  settingsTitle: 'Click a BUFF icon to set reminders',
  settingsLead: 'Choose when and how to be reminded.',
  settingsDescription: ' Set the lead time and voice alerts. Icons blink automatically before expiry.',
  settingsHint: 'Each BUFF has its own reminders. Changes save automatically.',
  example: 'Example',
}

type Copy = typeof en

export const buffTourCopy: Record<AppLocale, Copy> = {
  en,
  'zh-CN': {
    barTitle: 'BUFF 快结束时，提醒你',
    barLead: '添加 BUFF 并连接游戏窗口', barDescription: '后，自动监控。',
    barHint: '图标可拖动排序，把重要的放在前面。',
    addTitle: '点「＋」，添加 BUFF',
    addLead: '搜索技能或道具', addDescription: '，点选图标即可添加。',
    addHint: '也可上传、粘贴或拖入自己的图标图片。',
    settingsTitle: '点 BUFF 图标，设置提醒',
    settingsLead: '提前几秒、语音播报', settingsDescription: '，按需设置；临期图标自动闪烁。',
    settingsHint: '每个 BUFF 单独设置，修改后自动保存。',
    example: '效果示意',
  },
  'zh-TW': {
    barTitle: 'BUFF 即將結束時，提醒你',
    barLead: '新增 BUFF 並連接遊戲視窗', barDescription: '後，自動監控。',
    barHint: '圖示可拖曳排序，把重要的放在前面。',
    addTitle: '點「＋」，新增 BUFF',
    addLead: '搜尋技能或道具', addDescription: '，點選圖示即可新增。',
    addHint: '也可上傳、貼上或拖入自己的圖示圖片。',
    settingsTitle: '點 BUFF 圖示，設定提醒',
    settingsLead: '提前幾秒、語音播報', settingsDescription: '，依需要設定；即將結束時圖示會自動閃爍。',
    settingsHint: '每個 BUFF 個別設定，修改後自動儲存。',
    example: '效果示意',
  },
  ja: {
    barTitle: 'BUFFが切れる前にお知らせ',
    barLead: 'BUFFを追加してゲーム画面を接続', barDescription: 'すると、自動で監視します。',
    barHint: 'アイコンをドラッグして、重要なBUFFを前へ。',
    addTitle: '「＋」を押してBUFFを追加',
    addLead: 'スキルやアイテムを検索', addDescription: 'して、アイコンを選ぶだけ。',
    addHint: '自分の画像のアップロード、貼り付け、ドラッグにも対応。',
    settingsTitle: 'BUFFアイコンを押して通知を設定',
    settingsLead: '通知する秒数・音声', settingsDescription: 'を好みに合わせて設定できます。終了間近のアイコンは自動で点滅します。',
    settingsHint: '通知はBUFFごとに設定でき、変更は自動保存されます。',
    example: '表示例',
  },
  ko: {
    barTitle: 'BUFF가 끝나기 전에 알려드려요',
    barLead: 'BUFF를 추가하고 게임 창을 연결하면', barDescription: ' 자동으로 감시합니다.',
    barHint: '아이콘을 드래그해 중요한 BUFF를 앞에 놓으세요.',
    addTitle: '「＋」를 눌러 BUFF 추가',
    addLead: '스킬이나 아이템을 검색하고', addDescription: ' 아이콘을 누르면 추가됩니다.',
    addHint: '직접 준비한 아이콘도 업로드·붙여넣기·드래그로 추가할 수 있어요.',
    settingsTitle: 'BUFF 아이콘을 눌러 알림 설정',
    settingsLead: '미리 알릴 시간·음성', settingsDescription: '을 원하는 대로 설정하세요. 종료가 임박하면 아이콘이 자동으로 깜박입니다.',
    settingsHint: 'BUFF별로 설정하며 변경 사항은 자동 저장됩니다.',
    example: '예시 화면',
  },
}
